<template>
  <div>
    <div class="order-type-enter-time" v-if="slotMode && !isMobile()">
      <div class="popup-container" :style="dateFieldStyles">
        <div class="top-inputs">
          <div class="half-field">
            <div class="input-icon-container">
              <!-- <img
                src="@/assets/icons/icon-calendar.svg"
                @click="$refs.programaticOpen.showCalendar()"
              /> -->
            </div>
            <date-picker
              name="deliveryDT"
              v-if="isDelivery"
              @closed="setTimes(deliveryDate)"
              v-model="deliveryDate"
              :disabledDates="deliveryDisabledDates"
              ref="programaticOpen"
            ></date-picker>
            <date-picker
              name="deliveryDT"
              v-else
              @closed="setTimes(pickupDate)"
              v-model="pickupDate"
              :disabledDates="pickupDisabledDates"
              ref="programaticOpen"
            ></date-picker>
          </div>
        </div>
      </div>
      <div
        v-if="isDelivery && dtimes.length > 0"
        :class="{
          'timeslots-container': !isMobile(),
          'timeslots-container-mobile': isMobile(),
        }"
      >
        <div v-if="asapSlot" class="timeslot-container asap">
          <div
            class="timeslot"
            :style="
              selectedDeliveryTime == asapSlot.time ? selectedSlotStyles : {}
            "
            @click="
              selectedDeliveryTime = asapSlot.time;
              selectedDeliveryTimeChange();
            "
          >
            ASAP
            <br />
            {{ asapSlot.format.toUpperCase() }}
          </div>
        </div>
        <div
          class="timeslot-container"
          v-for="slot in otherSlots"
          :key="slot.time.tc"
          @click="
            selectedDeliveryTime = slot.time;
            selectedDeliveryTimeChange();
          "
        >
          <div
            class="timeslot"
            :style="selectedDeliveryTime == slot.time ? selectedSlotStyles : {}"
          >
            {{ slot.format.toUpperCase() }}
          </div>
        </div>
      </div>
    </div>
    <div class="calendar-overlay" v-if="showOverlay && isMobile()">
      <div class="col-6" style="padding: 15px 20px 13px">
        <span class="material-icons md-36">
          <img
            src="@/assets/back-arrow.png"
            class="icon-back-arrow"
            @click="closeOverlay"
          />
        </span>
      </div>
      <div class="overlay-title rolld-primary-color">
        Choose {{ isDelivery ? "Delivery" : "Pickup" }}
        <br />
        Date
      </div>
      <date-picker
        name="deliveryDTP"
        v-if="isDelivery"
        @selected="setTimes"
        v-model="deliveryDate"
        :disabledDates="deliveryDisabledDates"
        :inline="true"
        calendar-class="inline-calendar"
      ></date-picker>
      <date-picker
        name="pickupDTP"
        v-else
        @selected="setTimes"
        v-model="pickupDate"
        :disabledDates="pickupDisabledDates"
        :inline="true"
        calendar-class="inline-calendar"
      ></date-picker>
      <div class="full-extras-footer" style="bottom: 1rem;">
        <button
          @click="closeOverlay"
          :style="mobileStyles.btn"
          class="btn btn-primary btn-confirm-overlay"
        >
          {{ $t("message.confirmDate") }}
        </button>
      </div>
    </div>
    <div
      class="deliver-date-component"
      v-if="isMobile()"
      :style="dateFieldStyles"
    >
      <div class="date-container" @click="openOverlay">
        <span class="day-of-week">{{ selectedDayOfWeek }}</span>
        <br />
        <span class="full-date">{{ selectedDateString }}</span>
      </div>
    </div>
    <div class="order-type-enter-time">
      <div v-if="isDelivery && isMobile()" class="select-container">
        <label
          for="date-select-delivery"
          style="display: block; margin: 14px 0 12px; font-size: 12px"
        >
          {{ fieldLabel }}

          <span style="color: red">&nbsp;*</span>
        </label>

        <select
          name="delivery-date"
          id="date-select-delivery"
          v-model="selectedDeliveryTime"
          @change="selectedDeliveryTimeChange"
        >
          <option
            v-for="slot in dtimes"
            :key="slot.time.tc"
            :value="slot.time"
          >
            {{ slot.format.toUpperCase() }}
          </option>
        </select>
      </div>
      <div v-if="!isDelivery" class="select-container">
        <label
          for="date-select-pickup"
          style="display: block; margin: 14px 0 12px; font-size: 12px"
        >
          {{ fieldLabel }}
          <span style="color: red">&nbsp;*</span>
        </label>
        <select
          name="delivery-date"
          id="date-select-pickup"
          v-model="selectedDeliveryTime"
          @change="selectedDeliveryTimeChange"
        >
          <option
            v-for="slot in pickupTimes"
            :key="slot.time.tc"
            :value="slot.time"
          >
            {{ slot.format.toUpperCase() }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vuejs-datepicker";
import {
  initPickupDeliveryTimes,
  getCurrentDate,
  getNexOpenDate,
  availablePickupDeliveryDates,
} from "../../../api/helpers/datetimeHelper";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { DateTime } from "luxon";
import {
  CONSTANT_ORDER_TYPE_DELIVERY,
  CONSTANT_ORDER_TYPE_PICKUP,
} from "../../../constans/strings";

export default {
  name: "EnterDeliveryTime",
  components: {
    DatePicker,
  },
  data() {
    return {
      selectedSlotIndex: 0,
      deliveryDate: new Date(),
      pickupDate: new Date(),
      deliveryTime: null,
      selectedDeliveryTime: null,
      deliveryDisabledDates: {},
      pickupDisabledDates: {},
      dtimes: [],
      pickupTimes: [],
      showOverlay: false,
    };
  },
  mounted() {
    this.setPickupDeliveryDates();
  },
  computed: {
    ...mapGetters([
      "desktopStyles",
      "selectedCompany",
      "getDeliveryDuration",
      "getOrderPreparationTime",
      "isDeliveryTimeSlotsEnable",
      "deliveryTimeSlots",
      "getSelectedMenuType",
      "getIsDoorDashDelivery",
      "mobileStyles",
    ]),
    slotMode() {
      return (
        this.isDelivery ||
        this.getSelectedMenuType == CONSTANT_ORDER_TYPE_PICKUP
      );
    },
    dateFieldStyles() {
      const isPickup = this.getSelectedMenuType == CONSTANT_ORDER_TYPE_PICKUP;
      const {
        EnablePreoderForDelivery,
        EnablePreoderForPickup,
      } = this.selectedCompany;

      const hideDateField =
        (this.isDelivery && !EnablePreoderForDelivery) ||
        (isPickup && !EnablePreoderForPickup);

      return hideDateField ? { display: "none" } : null;
    },
    isDelivery() {
      return this.getSelectedMenuType == CONSTANT_ORDER_TYPE_DELIVERY;
    },
    asapSlot() {
      var asap = this.dtimes.find((p) => p.format.indexOf("ASAP") >= 0);
      if (asap) {
        asap.format = asap.format.split("(")[1].split(")")[0];
      }
      return asap;
    },
    otherSlots() {
      if (this.asapSlot) {
        const lastIndex = /*this.dtimes.length > 9 ? 9 :*/ this.dtimes.length;
        return this.dtimes.slice(1, lastIndex);
      } else {
        return this.dtimes;
      }
    },
    selectedSlotStyles() {
      const styles = this.desktopStyles.btn;
      return {
        background: styles.background,
        color: styles.color,
        borderColor: styles.background,
      };
    },
    fieldLabel() {
      return this.isDelivery
        ? this.$t("message.deliveryTime")
        : this.$t("message.pickupTime");
    },
    selectedDayOfWeek() {
      var scheduledDate = this.isDelivery
        ? this.deliveryDate || null
        : this.pickupDate;
      return scheduledDate === null
        ? "..."
        : scheduledDate.toLocaleString("en-us", { weekday: "long" });
    },
    selectedDateString() {
      const deliveryDate = this.isDelivery
        ? this.deliveryDate
        : this.pickupDate;
      if (!deliveryDate) {
        return "...";
      } else {
        const monthNames = new Array(
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        );

        var date = deliveryDate.getDate();
        var month = deliveryDate.getMonth();
        var year = deliveryDate.getFullYear();

        return monthNames[month].concat(" ", date, ", ", year);
      }
    },
  },
  methods: {
    ...mapActions(["applyDeliveryAddress"]),
    ...mapMutations(["setScheduledDeliveryTime"]),
    selectSlot(index) {
      this.selectedSlotIndex = index;
    },
    setPickupDeliveryDates() {
      var date = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      this.deliveryDisabledDates = availablePickupDeliveryDates(
        this.selectedCompany.BlackoutDates,
        this.getOrderPreparationTime,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation ||
          this.selectedCompany.EnablePreoderForDelivery,
        date,
        this.selectedCompany.NumberOfDaysInAdvanceForDelivery,
        this.selectedCompany.PreOrderCutOffDays
          ? (this.selectedCompany.PreOrderCutOffDays || 0) + 1 // plus today
          : this.selectedCompany.PreOrderCutOffDays || 0,
        this.selectedCompany.PreOrderCutOffTime,
        this.deliveryTimeSlots,
        this.isDeliveryTimeSlotsEnable
      );

      this.pickupDisabledDates = availablePickupDeliveryDates(
        this.selectedCompany.BlackoutDates,
        this.getOrderPreparationTime,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation ||
          this.selectedCompany.EnablePreoderForPickup,
        date,
        this.selectedCompany.NumberOfDaysInAdvanceForPickup
      );
      var startDate = date;
      var prePreprationTime = this.getOrderPreparationTime || 0;
      var nextOpenDay = getNexOpenDate(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        date.plus({
          minutes: prePreprationTime,
        }),
        true,
        this.deliveryTimeSlots,
        this.isDeliveryTimeSlotsEnable
      );
      if (nextOpenDay) {
        if (nextOpenDay.day != date.day) {
          let cutOffTime = DateTime.fromFormat(
            date.toFormat("dd MMMM yyyy") +
              " " +
              (this.selectedCompany.PreOrderCutOffTime || "00:00"),
            "dd MMMM yyyy hh:mm",
            { zone: date.zone }
          );
          let cutOffDays = (this.selectedCompany.PreOrderCutOffDays || 0) + 1; // plus today
          if (date > cutOffTime && this.selectedCompany.PreOrderCutOffDays) {
            cutOffDays++;
          }
          if (cutOffDays > 0 && this.selectedCompany.PreOrderCutOffTime) {
            startDate = getNexOpenDate(
              this.selectedCompany.BlackoutDates,
              this.selectedCompany.OperatingHours,
              date.plus({
                days: cutOffDays,
              }),
              false,
              this.deliveryTimeSlots,
              this.isDeliveryTimeSlotsEnable
            );
          } else {
            startDate = getNexOpenDate(
              this.selectedCompany.BlackoutDates,
              this.selectedCompany.OperatingHours,
              date.plus({
                minutes:
                  prePreprationTime +
                  (this.selectedCompany.DeliveryTimeInterval || 0),
              }),
              true,
              this.deliveryTimeSlots,
              this.isDeliveryTimeSlotsEnable
            );
          }
        } else {
          startDate = getNexOpenDate(
            this.selectedCompany.BlackoutDates,
            this.selectedCompany.OperatingHours,
            date.plus({
              minutes: prePreprationTime,
            }),
            true,
            this.deliveryTimeSlots,
            this.isDeliveryTimeSlotsEnable
          );
        }
      }

      this.deliveryDate = startDate ? startDate.toJSDate() : null;

      startDate = getNexOpenDate(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        date.plus({
          minutes: prePreprationTime,
        })
      );
      this.pickupDate = this.startdate = startDate
        ? startDate.toJSDate()
        : null;

      this.setDeliveryTimes(this.deliveryDate);
      this.setPickupTimes(this.pickupDate);
    },
    isPreOrder() {
      if (!this.deliveryDate) {
        return false;
      }
      var date = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      var deliveryDate = DateTime.fromISO(
        DateTime.fromJSDate(this.deliveryDate).toISODate()
      );
      if (date.day != deliveryDate.day) {
        return true;
      }
      return false;
    },
    selectedDeliveryTimeChange() {
      if (this.isDelivery) {
        this.setScheduledDeliveryTime(
          new Date(this.selectedDeliveryTime).toISOString()
        );
      }
      this.$emit(
        "set-scheduled-time",
        new Date(this.selectedDeliveryTime).toISOString()
      );
    },
    setTimes(date) {
      if (this.isDelivery) {
        this.setDeliveryTimes(date, true);
      } else {
        this.setPickupTimes(date, true);
      }
    },
    setDeliveryTimes(date, recursive = false) {
      var dpDate = new Date(DateTime.local().ts);
      if (this.deliveryDate != date) {
        this.deliveryDate = date;
      }
      dpDate = this.deliveryDate;
      this.dtimes = initPickupDeliveryTimes(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        this.getOrderPreparationTime,
        dpDate,
        getCurrentDate(this.selectedCompany.TimezoneIanaFormat),
        this.getDeliveryDuration,
        true,
        this.selectedCompany.DeliveryTimeInterval,
        this.deliveryTimeSlots,
        this.isDeliveryTimeSlotsEnable,
        this.isPreOrder ? this.selectedCompany.PreOrderCutOffTime : null
      );
      if (this.dtimes.length > 0) {
        if (this.isDelivery) {
          this.selectedDeliveryTime = this.dtimes[0].time;
          this.selectedDeliveryTimeChange();
        }
      } else if (!recursive && this.selectedCompany.EnablePreoderForDelivery) {
        var currentDate = getCurrentDate(
          this.selectedCompany.TimezoneIanaFormat
        );
        var startDate = currentDate;
        startDate = getNexOpenDate(
          this.selectedCompany.BlackoutDates,
          this.selectedCompany.OperatingHours,
          currentDate.plus({
            days: 1,
          }),
          false,
          this.deliveryTimeSlots,
          this.isDeliveryTimeSlotsEnable
        );
        this.deliveryDate = startDate ? startDate.toJSDate() : null;
        this.setDeliveryTimes(this.deliveryDate, true);
        return;
      } else {
        this.selectedDeliveryTime = null;
      }

      if (this.dtimes.length == 0) {
        this.setScheduledDeliveryTime(null);
      } else {
        this.setScheduledDeliveryTime(
          new Date(this.selectedDeliveryTime).toISOString()
        );
      }
    },
    setPickupTimes(date, recursive = false) {
      var dpDate = null;
      if (this.pickupDate != date) {
        this.pickupDate = date;
      }
      dpDate = this.pickupDate;
      this.pickupTimes = initPickupDeliveryTimes(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        this.getOrderPreparationTime,
        dpDate,
        getCurrentDate(this.selectedCompany.TimezoneIanaFormat),
        0,
        false,
        this.selectedCompany.PickupTimeInterval
      );
      if (this.pickupTimes.length > 0) {
        if (this.pickupTimes[0] && !this.isDelivery) {
          this.selectedDeliveryTime = this.pickupTimes[0].time;
          this.selectedDeliveryTimeChange();
        }
      } else if (!recursive && this.selectedCompany.EnablePreoderForPickup) {
        var currentDate = getCurrentDate(
          this.selectedCompany.TimezoneIanaFormat
        );
        var startDate = currentDate;
        startDate = getNexOpenDate(
          this.selectedCompany.BlackoutDates,
          this.selectedCompany.OperatingHours,
          currentDate.plus({
            days: 1,
          }),
          true,
          null,
          false
        );
        this.pickupDate = startDate ? startDate.toJSDate() : null;
        if (this.pickupDate) this.setPickupTimes(this.pickupDate, true);
        return;
      }
    },
    openOverlay() {
      this.showOverlay = true;
    },
    closeOverlay() {
      this.showOverlay = false;
    },
  },
};
</script>
